<template>
  <div>
    <div 
      @click="launchFile()"
      style="position: relative;">
      <slot name="activator"></slot>
    </div>

    <input 
      type="file"
      accept="image/png, image/gif, image/jpg, image/jpeg"
      ref="file"
      :name="filename"
      v-on:change="changeImage($event.target.files)"
      style="display:none">

    <v-dialog 
      v-model="dialog"
      width="500">
      <v-card
        class="pa-0 ma-0"
        flat>
        <v-card
          color="red accent-2">
          <v-list-item>
            <v-list-item-avatar 
              color="red accent-2" 
              size="30">
              <v-icon color="white" large>mdi-alert</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-card-text 
                class="caption white--text pa-0">
                {{ message.error }}
              </v-card-text>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";

  export default {
    name: 'upload-folder',
    data: () => ({
      dialog: false,
      filename: 'file',
      message: {
        success: '',
        error: ''
      },
      process: {
        form: false
      },

      onProgress: 0
    }),
    computed: {
      baseurllocal () {
        return this.$store.state.baseurllocal
      }
    },
    methods: {
      launchFile () {
        this.$refs.file.click()
      },
      changeImage (file) {
        let image = file[0]
        if (file.length > 0) {
          if (image.type != 'image/jpg' && image.type != 'image/jpeg' && image.type != 'image/png' && image.type != 'image/gif') {
            this.dialog = true
            this.message.error = 'Silahkan pilih gambar dengan format .jpg / .jpeg / .png / .gif'
          } 
          
          // else if (image.size > 5242880) {
          //   this.dialog = true
          //   this.message.error = 'Maksimal gambar 5MB'
          // } 
          
          else {
            // let formData = new FormData()
            //     formData.append('file', image)
            //     formData.append('type', 'assets')

            // console.log(formData, image)

            // this.process.form = true
            // this.$emit('input', {
            //   process : this.process.form
            // })

            // let BASEURLLOCAL = this.baseurllocal !== '' && this.baseurllocal !== null ? this.baseurllocal  + '/' : process.env.VUE_APP_API_CDN

            // fetch(`${BASEURLLOCAL}upload`, {
            //   method: 'POST',
            //   body: formData
            // })
            // .then(res => res.json())
            // .then(response => {
            //   this.process.form = false

            //   // this.$emit('input', response.result)

            //   this.$emit('input', {
            //     file_name: response.results.data.filename,
            //     file_url: response.results.data.fileuri
            //   })
            // })

            this.save(image)
          }
        }
      },

      save (image) {
        let formData = new FormData()
          formData.append('file', image)
          formData.append('type', 'assets')
          
        this.process.form = true
        this.$emit('input', {
          process : this.process.form,
          onProgress : this.onProgress
        })

        let BASEURLLOCAL = this.baseurllocal !== '' && this.baseurllocal !== null ? this.baseurllocal  + '/' : process.env.VUE_APP_API_CDN

        const xhr = new XMLHttpRequest();

        xhr.open('POST', `${BASEURLLOCAL}upload`, true);
        xhr.setRequestHeader('Token', `Bearer ${TokenService.getToken()}`);

        xhr.upload.onprogress = (event) => {
          if (event.lengthComputable) {
            this.onProgress = Math.round((event.loaded / event.total) * 100);

            this.$emit('input', {
              process : this.process.form,
              onProgress : this.onProgress
            })
          }
        };

        xhr.onload = () => {
          if (xhr.status === 200) {
            let data = JSON.parse(xhr.response);

            if (data.status === 200) {
              this.$emit('input', {
                file_name: data.results.data.filename,
                file_url: data.results.data.fileuri
              })
            } else {
              this.dialog = true
              this.message.error = data?.message
            }

            this.onProgress = 0;

            this.process.form = false;

            this.$refs.file.value = null;

          } else {
            this.dialog = true
            this.message.error = 'Upload failed'

            this.onProgress = 0;

            this.process.form = false;

            this.$refs.file.value = null;
          }
        };

        xhr.onerror = () => {
          this.dialog = true
          this.message.error = 'Upload error'

          this.onProgress = 0;

          this.process.form = false;
          
          this.$refs.file.value = null;
        };

        xhr.send(formData);
      }
    }
  }
</script>